// REWARD ACTION TYPES
export const FETCH_REWARDS_REQUEST = 'FETCH_REWARDS_REQUEST';
export const FETCH_REWARDS_SUCCESS = 'FETCH_REWARDS_SUCCESS';
export const FETCH_REWARDS_FAILURE = 'FETCH_REWARDS_FAILURE';

export const ADD_REWARD_REQUEST = 'ADD_REWARD_REQUEST';
export const ADD_REWARD_SUCCESS = 'ADD_REWARD_SUCCESS';
export const ADD_REWARD_FAILURE = 'ADD_REWARD_FAILURE';

export const UPDATE_REWARD_REQUEST = 'UPDATE_REWARD_REQUEST';
export const UPDATE_REWARD_SUCCESS = 'UPDATE_REWARD_SUCCESS';
export const UPDATE_REWARD_FAILURE = 'UPDATE_REWARD_FAILURE';

export const DELETE_REWARD_REQUEST = 'DELETE_REWARD_REQUEST';
export const DELETE_REWARD_SUCCESS = 'DELETE_REWARD_SUCCESS';
export const DELETE_REWARD_FAILURE = 'DELETE_REWARD_FAILURE';

export const SET_REWARD_FIELD_ERRORS = 'SET_REWARD_FIELD_ERRORS';
